/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/no-children-prop */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import Toast from 'react-native-toast-message';
import ModalTopRounded from '@components/modal/ModalTopRounded';
import Colors from '@global/colors';
import { isWeb, isMobileWeb } from '@global/screens';
import { showPopup } from '@/store/modal';
import Image from '@components/global/Image';
import SociollaText from '@components/sociolla/SociollaText';
import importTemplate from '@/assets/csv/template-import-user';
import ModalUpload from '@components/modal/ModalUpload';

import { MsAccount } from '@api/ms-account';

const UserCreateOption = (props) => {
  const dispatch = useDispatch();
  const showImportModalUser = useSelector(
    (state) => state.modal.showImportModalUser,
  );

  const createUser = () => {
    dispatch(showPopup({ name: 'userCreateOption', value: false }));
    setTimeout(() => {
      props.navigation.replace('UserFormScreen');
    }, 250);
  };

  const chooseFile = async () => {
    dispatch(
      showPopup({
        name: 'showImportModalUser',
        value: true,
      }),
    );
    dispatch(showPopup({ name: 'userCreateOption', value: false }));
  };

  const handleImport = async (url) => {
    const failedProcess = () => {
      Toast.show({ text1: 'A system error occurred', type: 'error' });
      dispatch(showPopup({ name: 'isLoading', value: false }));
      dispatch(showPopup({ name: 'userCreateOption', value: false }));
    };
    try {
      dispatch(
        showPopup({
          name: 'showImportModalUser',
          value: false,
        }),
      );
      const response = await MsAccount.createBulkUser({ url });
      if (response.status == 200) {
        Toast.show({
          text1: 'Import Create User In Progress',
          type: 'success',
        });
      } else {
        failedProcess();
      }
    } catch (error) {
      console.log(error);
      failedProcess();
    }
  };

  return (
    <View>
      <ModalTopRounded
        title="Add User"
        visible={props.show}
        maxWidth={isWeb && !isMobileWeb ? 500 : '100%'}
        onClose={() =>
          dispatch(showPopup({ name: 'userCreateOption', value: false }))
        }
        children={
          <View style={styles.userCreate}>
            <TouchableOpacity
              activeOpacity={0.6}
              style={styles.itemOption}
              onPress={() => createUser()}>
              <Image
                style={{ width: 43, height: 43 }}
                width={43}
                height={43}
                source={require('@assets/img/icons/add-manually.png')}
              />
              <SociollaText style={styles.itemText}>Add Manually</SociollaText>
            </TouchableOpacity>
            <TouchableOpacity
              activeOpacity={0.6}
              style={styles.itemOption}
              onPress={() => chooseFile()}>
              <Image
                style={{ width: 35, height: 43 }}
                width={35}
                height={43}
                source={require('@assets/img/icons/import-csv.svg')}
              />
              <SociollaText style={styles.itemText}>Import CSV</SociollaText>
            </TouchableOpacity>
          </View>
        }
      />
      {showImportModalUser ? (
        <ModalUpload
          show={showImportModalUser}
          onClose={() =>
            dispatch(
              showPopup({
                name: 'showImportModalUser',
                value: false,
              }),
            )
          }
          templateUrl={importTemplate}
          onUpload={handleImport}
          autoUploadS3={true}
          name={'import_user'}
          validHeader={[
            'name',
            'email',
            'country',
            'phone',
            'role',
            'branch',
            'sales_team',
            'sales_code',
            'salesman_type',
          ]}
        />
      ) : (
        false
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  userCreate: {
    width: '100%',
    paddingHorizontal: isWeb ? 25 : 15,
    paddingTop: isWeb ? 25 : 15,
    paddingBottom: isWeb ? 40 : 15,
    flexDirection: 'row',
    justifyContent: 'center',
    // maxHeight: isMobileWeb ? 'auto' : (isWeb ? (dimension.height - 55) : 'auto')
  },
  itemOption: {
    padding: 15,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 5,
    borderColor: Colors.grey0,
    borderWidth: 1,
    marginHorizontal: isWeb ? 15 : 10,
  },
  itemText: {
    fontSize: 14,
    marginTop: 15,
  },
});

export default UserCreateOption;
